export default __webpack_public_path__ + "static/media/nextjs.096fcc61.svg";